module.exports = __webpack_public_path__ + "static/media/banner.e1a08309.png";